import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { styles as sharedStyles } from '@swf/account';
import { select } from '@swf/core/store';

import View from '../View/View';

import {
  TXTCLI_Receive_Tournament_Money_throu_ELL,
  TXTCLI_Tournament_Money,
  TXTCLI_Unregistering_from_a_tournamen_ELL,
  TXTCLI_Use_Tournament_Money_to_regist_ELL,
  TXTCLI_Winning_more_than_one_satellit_ELL,
  TXTWCL_From_a_Chest_or_as_part_of_spe_ELL
} from './TournamentMoney.messages.json';
import Balances from './components/Balances/Balances';
import TournamentMoneyNonPokerContent from './components/TournamentMoneyNonPokerContent/TournamentMoneyNonPokerContent';
import TournamentMoneyPokerContent from './components/TournamentMoneyPokerContent/TournamentMoneyPokerContent';

export const TournamentMoneyBody: React.FC<Partial<ClassNameProp>> = ({ className }) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const webPokerEnabled = useFeature(FeatureFlag.WebPokerEnabled);

  return (
    <>
      <p className={className}>
        <Translation {...TXTCLI_Use_Tournament_Money_to_regist_ELL} />
      </p>
      <Balances />
      <Translation tagName="p" {...TXTCLI_Receive_Tournament_Money_throu_ELL} />
      <ul className={sharedStyles.list}>
        <Translation tagName="li" {...TXTWCL_From_a_Chest_or_as_part_of_spe_ELL} />
        <Translation tagName="li" {...TXTCLI_Winning_more_than_one_satellit_ELL} />
        <Translation tagName="li" {...TXTCLI_Unregistering_from_a_tournamen_ELL} />
      </ul>
      {isEmbedded || webPokerEnabled ? (
        <TournamentMoneyPokerContent isEmbedded={isEmbedded} />
      ) : (
        <TournamentMoneyNonPokerContent />
      )}
    </>
  );
};

const TournamentMoney: React.FC = () => (
  <View title={<Translation {...TXTCLI_Tournament_Money} />}>
    <TournamentMoneyBody />
  </View>
);

export default TournamentMoney;
